//AdminRutas
import { DataTable } from 'primereact/datatable';
import { useEffect, useRef, useState } from 'react';
import {
    crearUbicacionSimple,
    modificarUbicacionSimple,
    recuperaSimpleUbicacion
} from '../../services/Siniestro/SiniestroService';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import DibujadorDeRuta from './DibujadorDeRuta';
import { InputText } from 'primereact/inputtext';

const AdminRutas = () => {
    const [cargando, setCargando] = useState(false);
    const [lstRutas, setLstRutas] = useState([]);
    const [visibleMapa, setVisibleMapa] = useState(false);
    const [cambioRuta, setCambioRuta] = useState(false);
    const [rutaInicial, setRutaInicial] = useState([]);
    const [soloConsulta, setSoloConsulta] = useState(false);
    const [ruta, setRuta] = useState({});

    const addRutaToast = useRef();

    useEffect(() => {
        const obtieneZonasUbicacion = async () => {
            const CODE_TIPORUTA_UBICACION = 'UBI-0000-0000-0006';
            try {
                setCargando(true);
                const data = await recuperaSimpleUbicacion(CODE_TIPORUTA_UBICACION);
                console.log('SALIDA RUTAS: ', data);
                setLstRutas(data);
            } catch (error) {
                console.error('ERROR: Al obtener Ubicaciones de Zonas');
            } finally {
                setCargando(false);
            }
        };
        obtieneZonasUbicacion();
    }, [cambioRuta]);

    const actionBody = (rowData) => {
        return (
            <div className="flex gap-2 justify-content-center">
                <Button
                    icon="pi pi-eye"
                    className="p-button-rounded p-button-warning p-button-text"
                    style={{ width: '2rem', height: '2rem', fontSize: '0.8rem' }}
                    tooltip="Ver Ruta"
                    onClick={() => verMapaVer(rowData)}
                />
                <Button
                    icon="pi pi-pencil"
                    className="p-button-rounded p-button-info p-button-text"
                    style={{ width: '2rem', height: '2rem', fontSize: '0.8rem' }}
                    tooltip="Editar Ruta"
                    onClick={() => verMapaEditar(rowData)}
                />
            </div>
        );
    };

    const verMapaNuevo = () => {
        setRutaInicial('[]');
        setRuta({});
        setSoloConsulta(false);
        setVisibleMapa(true);
    };

    const verMapaEditar = (rowData) => {
        let coordenadasRaw = rowData.area.replace('LINESTRING (', '').replace(')', '');
        let puntosArray = coordenadasRaw.split(', ').map((par) => {
            const [lat, lng] = par.trim().split(' ');
            return { lat: parseFloat(lat), lng: parseFloat(lng) };
        });
        const propParaComponente = JSON.stringify(puntosArray);
        setRutaInicial(propParaComponente);
        setRuta(rowData);
        setSoloConsulta(false);
        setVisibleMapa(true);
    };

    const verMapaVer = (rowData) => {
        //console.log('ESTOS SON LOS DATOS.... : ', rowData);

        let coordenadasRaw = rowData.area.replace('LINESTRING (', '').replace(')', '');

        let puntosArray = coordenadasRaw.split(', ').map((par) => {
            const [lat, lng] = par.trim().split(' ');
            return { lat: parseFloat(lat), lng: parseFloat(lng) };
        });
        //puntosArray.pop();

        const propParaComponente = JSON.stringify(puntosArray);
        setRutaInicial(propParaComponente);
        setRuta(rowData);
        setSoloConsulta(true);
        setVisibleMapa(true);
    };

    const ocultarMapa = () => {
        setVisibleMapa(false);
    };

    const confirmaMapa = async (retorno) => {
        setVisibleMapa(false);
        try {
            setCargando(true);
            const objPost = {
                nombre: retorno.nombre,
                latitud: 0,
                longitud: 0,
                area: retorno.ruta,
                atributos: ''
            };
            const CODE_TIPOUBICACION_ZONA = 'UBI-0000-0000-0006';
            let data;
            if (ruta?.ubicacionId) {
                objPost['codigo'] = ruta?.codigo;
                objPost['ubicacionId'] = ruta?.ubicacionId;
                data = await modificarUbicacionSimple(objPost, CODE_TIPOUBICACION_ZONA);
            } else {
                // hay que crear la Ubicacion
                objPost['codigo'] = crypto.randomUUID();
                data = await crearUbicacionSimple(objPost, CODE_TIPOUBICACION_ZONA);
            }
            if (data.ubicacionId) {
                addRutaToast.current.show({
                    severity: 'success',
                    summary: 'Exito',
                    detail: 'Ruta registrada con Exito'
                });
                setCambioRuta((prev) => !prev);
            }
        } catch (error) {
            addRutaToast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'ERROR al crear Zona en Ubicacion'
            });
        } finally {
            setCargando(false);
        }
    };

    // filtros
    const [filtros, setFiltros] = useState({
        global: { value: null, matchMode: 'contains' },
        nombre: { value: null, matchMode: 'contains' }
    });
    // Estado para los valores visuales de los filtros
    const [valoresFiltros, setValoresFiltros] = useState({
        nombre: '',
        global: ''
    });
    const textoFilterTemplate = (options, field) => {
        return (
            <InputText
                value={valoresFiltros[field]}
                onChange={(e) => {
                    const nuevoValor = e.target.value;
                    // Actualizamos el valor visual
                    setValoresFiltros((prev) => ({ ...prev, [field]: nuevoValor }));

                    // Actualizamos el filtro real después de un pequeño delay
                    setTimeout(() => {
                        const newFilters = { ...filtros };
                        newFilters[field].value = nuevoValor;
                        setFiltros(newFilters);
                        options.filterApplyCallback(nuevoValor);
                    }, 10);
                }}
                placeholder={`Filtro ${field}`}
                className="w-full"
            />
        );
    };

    return (
        <div className="card">
            <Toast ref={addRutaToast} />
            <Dialog visible={visibleMapa} onHide={() => setVisibleMapa(false)} style={{ width: '60vw' }}>
                <DibujadorDeRuta
                    onConfirmar={confirmaMapa}
                    onCancelar={ocultarMapa}
                    rutaInicial={rutaInicial}
                    soloConsulta={soloConsulta}
                    datRuta={ruta}
                />
            </Dialog>
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-12 md:col-12">
                    <DataTable
                        value={lstRutas}
                        showGridlines
                        size="small"
                        paginator
                        rows={5}
                        rowsPerPageOptions={[5, 10, 25]}
                        responsiveLayout="scroll"
                        emptyMessage="No hay Rutas registradas"
                        loading={cargando}
                        loadingIcon="pi pi-spin pi-cog"
                        filters={filtros}
                        filterDisplay="row"
                    >
                        <Column
                            header="Nombre"
                            field="nombre"
                            filter
                            filterPlaceholder="Filtro Puesto"
                            filterElement={(options) => textoFilterTemplate(options, 'nombre')}
                        />
                        <Column header="Acciones" body={actionBody} />
                    </DataTable>
                </div>
                <div className="field col-12 md:col-8">
                    <label style={{ visibility: 'hidden' }}>Texto oculto</label>
                </div>
                <div className="field col-12 md:col-4">
                    <Button label="Adicion" icon="pi pi-plus" onClick={verMapaNuevo} />
                </div>
            </div>
        </div>
    );
};

export default AdminRutas;
